export default {
  SUBSCRIPTION_PLAN: {
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
  },
  SUBSCRIPTION_STATUS: {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
    PAUSED: 'PAUSED',
    PAST_DUE: 'PAST_DUE',
  },
}
